import { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../lib/api';

interface MeUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  accountId?: string | null;
}

export default function Account() {
  const navigate = useNavigate();
  const [user, setUser] = useState<MeUser | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = localStorage.getItem('auth_token');
    if (!token) {
      navigate('/login');
      return;
    }

    const fetchMe = async () => {
      try {
        const { data } = await api.get('/auth/me');
        setUser(data.user);
      } catch (e: any) {
        setError(e?.response?.data?.message || 'Failed to load account');
      } finally {
        setLoading(false);
      }
    };

    fetchMe();
  }, [navigate]);

  const logout = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('refresh_token');
    navigate('/login');
  };

  if (loading) {
    return (
      <div className="container-custom pt-28 sm:pt-32 pb-16">
        <div className="max-w-md mx-auto card">Loading…</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container-custom pt-28 sm:pt-32 pb-16">
        <div className="max-w-md mx-auto card">
          <div className="text-red-600 mb-4">{error}</div>
          <Link to="/login" className="btn-primary inline-block">Go to Login</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="container-custom pt-28 sm:pt-32 pb-16">
      <div className="max-w-2xl mx-auto card">
        <h1 className="text-2xl font-semibold mb-6">My Account</h1>
        {user && (
          <div className="space-y-3">
            <div className="flex items-center justify-between">
              <div>
                <div className="text-sm text-gray-500">Name</div>
                <div className="font-medium">{user.firstName} {user.lastName}</div>
              </div>
              <button onClick={logout} className="bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-2xl">Logout</button>
            </div>
            <div>
              <div className="text-sm text-gray-500">Email</div>
              <div className="font-medium">{user.email}</div>
            </div>
            {user.role && (
              <div>
                <div className="text-sm text-gray-500">Account Type</div>
                <div className="font-medium">{user.role === 'CUSTOMER' ? 'Customer' : user.role}</div>
              </div>
            )}
            {user.accountId && (
              <div>
                <div className="text-sm text-gray-500">Facility</div>
                <div className="font-medium">Linked account ID: {user.accountId}</div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
